import React, { useEffect } from 'react';

const CosmicPage = () => {
  useEffect(() => {
    // Redirect to standalone HTML page
    window.location.href = '/cosmic.html';
  }, []);

  return null;
};

export default CosmicPage;
